/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wifi_Mesh_With_Associated_GatewaysInputs */



/**
* | output |
* | --- |
* | "A wifi Mesh with associated gateways" |
*
* @param {Wifi_Mesh_With_Associated_GatewaysInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const wifi_mesh_with_associated_gateways = /** @type {((inputs?: Wifi_Mesh_With_Associated_GatewaysInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wifi_Mesh_With_Associated_GatewaysInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("A wifi Mesh with associated gateways")
	return /** @type {LocalizedString} */ ("Un wifi Mesh avec des box associées")
});